import { useStyleRegister } from '@ant-design/cssinjs';
import { useContext } from 'react';
import { genLinkStyle } from '../../style';
import { ConfigContext } from '../../config-provider/context';
import { mergeToken, statisticToken, useToken } from '../index';
import warning from '../../_util/warning';
export default function genComponentStyleHook(component, styleFn, getDefaultToken) {
    return (prefixCls) => {
        const [theme, token, hashId] = useToken();
        const { getPrefixCls, iconPrefixCls } = useContext(ConfigContext);
        const rootPrefixCls = getPrefixCls();
        if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test') {
            /* istanbul ignore next */
            warning(false, 'Next', '\n\nYou are using dev version, ' +
                'which is used for validating and may not same as final release version.\n\n' +
                'DO NOT USE IN YOUR PRODUCTION!\n\n' +
                'Ref:#33862 - What is in experimental?\n' +
                'https://github.com/ant-design/ant-design/issues/33862#user-content-alpha-offset');
        }
        // Generate style for all a tags in antd component.
        useStyleRegister({ theme, token, hashId, path: ['Link'] }, () => ({
            '&': genLinkStyle(token),
        }));
        return [
            useStyleRegister({ theme, token, hashId, path: [component, prefixCls] }, () => {
                const { token: proxyToken, flush } = statisticToken(token);
                const defaultComponentToken = typeof getDefaultToken === 'function' ? getDefaultToken(proxyToken) : getDefaultToken;
                const overrideComponentToken = token[component];
                // Only merge token specified in interface
                const mergedComponentToken = Object.assign({}, defaultComponentToken);
                if (overrideComponentToken) {
                    Object.keys(mergedComponentToken).forEach(key => {
                        var _a;
                        mergedComponentToken[key] = (_a = overrideComponentToken[key]) !== null && _a !== void 0 ? _a : mergedComponentToken[key];
                    });
                }
                const componentCls = `.${prefixCls}`;
                const mergedToken = mergeToken(proxyToken, {
                    componentCls,
                    prefixCls,
                    iconCls: `.${iconPrefixCls}`,
                    antCls: `.${rootPrefixCls}`,
                }, mergedComponentToken);
                const styleInterpolation = styleFn(mergedToken, {
                    hashId,
                    prefixCls,
                    rootPrefixCls,
                    iconPrefixCls,
                });
                flush(component, mergedComponentToken);
                return styleInterpolation;
            }),
            hashId,
        ];
    };
}
